<script>
import { openModal } from '@inscribe/signal';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'KeyboardShortcutListeners',
  computed: {
    ...mapGetters(['isChatAgentEnabled', 'chatIsOpen']),
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyboardShortcuts);
  },
  methods: {
    ...mapActions([
      'toggleChat',
      'toggleChatExpanded',
      'closeChat',
      'createNewConversationUuid',
    ]),
    openAndFocusGlobalSearchModal() {
      openModal('global-search-modal');
      setTimeout(() => {
        const searchInput = document.querySelector(
          '[data-modal-id="global-search-modal"] #searchInput',
        );
        if (searchInput) {
          searchInput.focus();
        }
      }, 50);
    },
    toggleChatSidebar() {
      this.toggleChat();
    },
    clearChat() {
      this.createNewConversationUuid();
    },
    handleKeyboardShortcuts(event) {
      // Check if cmd+k is pressed (or ctrl+k for non-Mac)
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        event.stopPropagation();
        this.openAndFocusGlobalSearchModal();
      }

      if (
        (event.metaKey || event.ctrlKey) &&
        event.key === 'i' &&
        this.isChatAgentEnabled
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleChatSidebar();
      }

      if (
        event.key === 'Escape' &&
        this.isChatAgentEnabled &&
        this.chatIsOpen
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.closeChat();
      }

      if (
        (event.metaKey || event.ctrlKey) &&
        event.key === 'c' &&
        this.isChatAgentEnabled &&
        this.chatIsOpen
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.clearChat();
      }

      if (
        (event.metaKey || event.ctrlKey) &&
        event.key === 'e' &&
        this.isChatAgentEnabled &&
        this.chatIsOpen
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleChatExpanded();
      }
    },
  },
};
</script>

<template>
  <!-- Intentionally empty -->
</template>
